import React from "react";
import SocialMediaIcons from "../../component/appBarcomponent/SocialMediaIcons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../../store/authSlice";
import { Icon } from "../../component/CreateIcons";
import "../css/Home.css";
import IOS from "../../assets/images/qrcode/Iosqr.jpeg";
import androidqr from "../../assets/images/qrcode/androidqr.jpeg";
import LOGO from "../assets/thurent-logo.svg";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getRegionContactInfo } from "../../util/contactRegion";

import config from "../../config";

function Footer() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const location = useLocation();
  const contact = getRegionContactInfo();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const activeContactInfo = contact || config.contactInfo?.india || config.contactInfo?.usa;
  const phoneNumber = activeContactInfo?.phone || "";
  const emailAddress = activeContactInfo?.email || "";
  const contactAddress = activeContactInfo?.address || "";
  const cin = config.isIndia ? "U62090TS2024PTC188514" : "";
  const gstin = config.isIndia ? "36AALCT2102L1ZB" : "";

  const routeAwareContactName =
    [
      "/about-us",
      "/contact",
      "/support",
      "/privacy-policy",
      "/all-policies",
      "/data-privacy",
      "/vendor-policy",
      "/user-policy",
      "/children-privacy",
      "/Cancellation-Refund_Policy",
      "/Shipping_DeliveryPolicy",
      "/Terms_Conditions",
    ].includes(location.pathname)
      ? activeContactInfo?.companyName || "Thurent LLC"
      : "Thurent LLC";

  const companyFullName = routeAwareContactName || "Thurent LLC";
  const openLink = (url) => {
    window.open(url, "_blank");
  };
  const logoutAccount = () => {
    dispatch(logOut()); // Dispatch the logout action to clear user state
    navigate("/"); // Redirect the user to the login page after logging out
    window.location.reload();
  };

  return (
    <div className="th-footer">
      <div className="th-footer__block__1">
        <div className="th-footer__container">
          <div className="th-footer__hero">
            <img src={LOGO} alt="thurent" width={"120px"} />
            <span className="th-footer__text">
              Book your event in minute, get full Control for much longer.
            </span>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
              }}
            >
              <SocialMediaIcons />
            </div>
            <div className="downloadappscss">
              <div>
                <img
                  src={IOS}
                  alt="QR code for iOS"
                  className="downloadqr"
                  onClick={() =>
                    openLink(
                      "https://apps.apple.com/in/app/thurent/id6747623495"
                    )
                  }
                />
              </div>


              <div>
                <img
                  src={androidqr}
                  alt="QR code for Android"
                  className="downloadqr"
                  onClick={() =>
                    openLink(
                      "https://play.google.com/store/search?q=thurent&c=apps&hl=en"
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="th-footer__links">
          <span className="th-footer__links__title">Quick Links</span>
          <div className="th-footer__links__nav">
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/")}
            >
              Home
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/about-us")}
            >
              About Us
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => navigate("/contact")}
            >
              Contact
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => {
                navigate("/child-safety");
                window.scrollTo({ top: 0 });
              }}
            >
              Child Safety (CSAE & CSAM)
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => {
                navigate("/all-policies");
                window.scrollTo({ top: 0 });
              }}
            >
              Policies
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => {
                navigate("/support");
                window.scrollTo({ top: 0 });
              }}
            >
              Support
            </p>
            <p
              className="th-footer__links__subtitle"
              onClick={() => {
                navigate("/Terms_Conditions");
                window.scrollTo({ top: 0 });
              }}
            >
              Terms & Conditions
            </p>
            {!isLoggedIn ? (
              <p
                className="th-footer__links__subtitle"
                onClick={() => navigate("/login")}
              >
                Log-in / Sign-Up
              </p>
            ) : (
              <p className="th-footer__links__subtitle" onClick={logoutAccount}>
                Logout
              </p>
            )}

          </div>
        </div>
      </div>
      <div className="th-footer__block">
        <div className="th-footer__links">
          <span className="th-footer__links__title">Services</span>
          <div className="th-footer__links__nav">
            <div className="th-footer_icons">
              <div style={{ marginTop: "3px" }}>
                <Icon id={1} size={20} />
              </div>
              <p
                className="th-footer__links__subtitle_services"
                onClick={() => {
                  navigate("/service/ai-enabled-event-details");
                  window.scrollTo({ top: 0 });
                }}
              >
                Checklist / To-do list
              </p>
            </div>
            <div className="th-footer_icons">
              <div style={{ marginTop: "3px" }}>
                <Icon id={9} size={20} />
              </div>
              <p
                className="th-footer__links__subtitle_services"
                onClick={() => {
                  navigate("/service/book-catering");
                  window.scrollTo({ top: 0 });
                }}
              >
                Order Catering
              </p>
            </div>
            <div className="th-footer_icons">
              <div style={{ marginTop: "3px" }}>
                <Icon id={8} size={20} />
              </div>
              <p
                className="th-footer__links__subtitle_services"
                onClick={() => {
                  navigate("/service/rental-services-for-events");
                  window.scrollTo({ top: 0 });
                }}
              >
                Rent from Tent Houses
              </p>
            </div>
            <div className="th-footer_icons">
              <div style={{ marginTop: "3px" }}>
                <Icon id={2} size={20} />
              </div>
              <p
                className="th-footer__links__subtitle_services"
                onClick={() => navigate("/service/invite")}
              >
                Send Invitation
              </p>
            </div>
            <div className="th-footer_icons">
              <div style={{ marginTop: "3px" }}>
                <Icon id={7} size={20} />
              </div>


              <p
                className="th-footer__links__subtitle_services"
                onClick={() => navigate("/service/hire-a-priest")}
              >
                Book A Priest
              </p>
            </div>
          </div>
        </div>
        <div className="th-footer__links">
          <span className="th-footer__links__title">Contact</span>
          <div className="th-footer__links__nav">
            <div className="th-footer__contact-group">
              {companyFullName && (
                <div className="th-footer__contact-row">
                  <i className="pi pi-user th-footer__contact-icon"></i>
                  <span className="th-footer__links__subtitle">{companyFullName}</span>
                </div>
              )}
              {phoneNumber && (
                <div className="th-footer__contact-row">
                  <i className="pi pi-phone th-footer__contact-icon"></i>
                  <span className="th-footer__links__subtitle">{phoneNumber}</span>
                </div>
              )}
              {contactAddress && (
                <div className="th-footer__contact-row th-footer__contact-row--address">
                  <i className="pi pi-map-marker th-footer__contact-icon"></i>
                  <span className="th-footer__links__subtitle th-footer__address-value">
                    {contactAddress.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        {index < contactAddress.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </span>
                </div>
              )}
              {emailAddress && (
                <div className="th-footer__contact-row">
                  <i className="pi pi-envelope th-footer__contact-icon"></i>
                  <span className="th-footer__links__subtitle">{emailAddress}</span>
                </div>
              )}
            </div>
            {cin && (
              <p className="th-footer__links__subtitle">
                <i className="pi pi-building"></i> CIN: {cin}
              </p>
            )}
            {gstin && (
              <p className="th-footer__links__subtitle">
                <i className="pi pi-credit-card"></i> GSTIN: {gstin}
              </p>
            )}
          </div>
          <span className="th-footer__links__title">
            Subscribe to our newsletter
          </span>
          <IconField>
            <InputIcon className="pi pi-send"></InputIcon>
            <InputText
              placeholder="Enter your email"
              className="th-event__subtext th-newsletter w-full"
            />
          </IconField>
        </div>
      </div>
    </div>
  );
}


export default Footer;



